import { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminPage = lazy(() => import("./admin/AdminPage"));
const GrupoPage = lazy(() => import("./grupo/GrupoPage"));
const CloserPage = lazy(() => import("./closer/CloserPage"));
const MotoristaPage = lazy(() => import("./motorista/MotoristaPage"));
const ClientePage = lazy(() => import("./cliente/ClientePage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const ScrapperPage = lazy(() => import("./scrapper/ScrapperPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/closer" component={CloserPage} />
                <Route path="/motorista" component={MotoristaPage} />
                <Route path="/cliente" component={ClientePage} />
                <Route path="/relatorio" component={RelatorioPage} />
                <Route path="/scrapper" component={ScrapperPage} />
                <Route path="/admin" component={AdminPage} />
                <Route path="/grupo" component={GrupoPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
